import React, { useEffect, useState, useImperativeHandle, useRef } from "react";
import ReactDOM from "react-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const DropdownTwo = React.forwardRef(({ title, bodyContent, style }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);

  const handleToggle = (event) => {
    event.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      (!dropdownContentRef.current ||
        !dropdownContentRef.current.contains(event.target))
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY, // Position the dropdown just below the title
        left: rect.left + window.scrollX, // Align it horizontally with the title
      });
    }
  }, [isOpen]);

  useImperativeHandle(ref, () => ({
    close: () => setIsOpen(false),
    open: () => setIsOpen(true),
  }));

  const dropdownContent = isOpen ? (
    <div
      ref={dropdownContentRef}
      className="bxShadow py-2 dropDown-Two"
      style={{
        position: "absolute",
        top: dropdownPosition.top,
        left: dropdownPosition.left,
        width: style?.width ?? "auto", // Use style.width if available, else "280%"
        cursor: "pointer",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {bodyContent}
    </div>
  ) : null;

  return (
    <div
      className=""
      ref={dropdownRef}
      onClick={handleToggle}
      style={{
        position: "relative",
        cursor: "pointer",
        backgroundColor: "#FFF",
      }}
    >
      <div
        className={`d-flex align-items-center justify-content-between  ${
          isOpen ? "srchbox-active" : "srchbox"
        }`}
        style={{ borderRadius: style?.outerdivborderRadius ?? "6px", gap: 40 }}
      >
        <p style={{ color: style?.titleColor ?? "#000" }}>{title}</p>
        <>{isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</>
      </div>

      {/* Use React Portal for top-level rendering */}
      {ReactDOM.createPortal(
        dropdownContent,
        document.body // Attach dropdown to the body
      )}
    </div>
  );
});

export default DropdownTwo;
